import request from '@/utils/request'

// 退货单列表
export function fetchList(data) {
	return request({
		url: '/oms/userOrder/return/queryReturnOrderInStockList',
		method: 'POST',
		data
	})
}

// 退货退款单详情
export function fetchDetail(params) {
	return request({
		url: '/oms/userOrder/return/queryReturnInfo',
		method: 'GET',
		params
	})
}

// 退货入库
export function returnOrderInStock(data) {
	return request({
		url: '/oms/userOrder/return/returnOrderInStock',
		method: 'POST',
		data
	})
}



// WEBPACK FOOTER //
// ./src/api/oms/return-instock.js